import React from "react";
import { Link } from "react-router-dom";
import { getThemeLabel, isSpecialTheme, standardThemes, THEME_SYSTEM } from "../utils";
import { cn } from "../../lib/utils";
import ThemeCard from "./ThemeCard";

const appearanceThemeChoices = [
  { id: THEME_SYSTEM, label: getThemeLabel(THEME_SYSTEM) },
  ...standardThemes,
];

/**
 * @param {Object} props
 * @param {string} props.theme
 * @param {function(string): void} props.setTheme
 * @param {function(Object): void} props.onUpdateSettings
 * @returns {JSX.Element}
 */
function AppearanceTab({ theme, setTheme, onUpdateSettings }) {
  const specialLabel = isSpecialTheme(theme) ? getThemeLabel(theme) : "";
  const specialLinkText = specialLabel
    ? `Special themes (beta) · ${specialLabel}`
    : "Special themes (beta)";

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-text-primary">Appearance</h2>
          <p className="mt-1 text-sm text-text-secondary sm:text-base">Choose your preferred theme</p>
        </div>
        <Link
          to="/settings/appearance/special"
          className={cn(
            "mt-1 shrink-0 text-right text-sm font-medium text-accent underline underline-offset-2",
            "hover:text-text-accent-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ui-ring"
          )}
        >
          {specialLinkText}
        </Link>
      </div>

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-text-primary sm:text-base">Theme</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {appearanceThemeChoices.map((themeOption) => (
            <ThemeCard
              key={themeOption.id}
              themeId={themeOption.id}
              label={themeOption.label}
              currentTheme={theme}
              setTheme={setTheme}
              onUpdateSettings={onUpdateSettings}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default AppearanceTab;
